import Vue from 'vue'
import Index from './Loading.vue'

let constructor,
  instance

Vue.prototype.Loading = {
  open (options) {
    if (constructor) {
      return
    }
    constructor = Vue.extend(Index)
    instance = new constructor({
      el: document.createElement('div')
    })

    instance.open = true
    for (var prop in options) {
      instance[prop] = options[prop]
    }
  },
  close () {
    if (instance) {
      instance.open = false
      constructor = instance = null
    }
  }
}
